import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { actionKey } from './constants';
import { uploadFile, uploadFiles, uploadProgress, uploadSuccess, uploadFailure, uploadFileImmediately, cancelFileUpload, clearInactiveUploads, uploadDocument, uploadDocumentProgress, uploadDocumentSuccess, uploadDocumentFailure, cancelDocumentUpload, uploadAttachment, uploadAttachmentImmediately, uploadAttachmentFailure, uploadAttachmentProgress, uploadAttachmentSuccess, cancelAttachmentUpload } from './actions';
import { handleActions } from 'redux-actions';
const defaultState = {
    fileUploads: [],
    fileUploadsWaiting: [],
    fileUploadsCompleted: [],
    attachmentUploads: [],
    attachmentUploadsWaiting: [],
    attachmentUploadsCompleted: [],
    documentUploads: {
        narf: undefined,
        sprf: undefined
    }
};
const actionHandlers = handleActions({
    [uploadFile.toString()]: (state, { payload })=>_object_spread_props(_object_spread({}, state), {
            fileUploadsWaiting: [
                ...state.fileUploadsWaiting,
                _object_spread({}, payload)
            ]
        }),
    [uploadFiles.toString()]: (state, { payload })=>_object_spread_props(_object_spread({}, state), {
            fileUploadsWaiting: [
                ...state.fileUploadsWaiting,
                ...payload.files
            ]
        }),
    [uploadFileImmediately.toString()]: (state, { payload })=>_object_spread_props(_object_spread({}, state), {
            fileUploads: [
                ...state.fileUploads,
                _object_spread({}, payload)
            ],
            fileUploadsWaiting: state.fileUploadsWaiting.filter((f)=>f.uploadId !== payload.uploadId)
        }),
    [uploadFailure.toString()]: (state, { payload: { uploadId, error } })=>_object_spread_props(_object_spread({}, state), {
            fileUploads: [
                ...state.fileUploads
            ].map((item)=>item.uploadId === uploadId ? _object_spread_props(_object_spread({}, item), {
                    error
                }) : item)
        }),
    [uploadProgress.toString()]: (state, { payload: { uploadId, progress } })=>_object_spread_props(_object_spread({}, state), {
            fileUploads: [
                ...state.fileUploads
            ].map((item)=>item.uploadId === uploadId ? _object_spread_props(_object_spread({}, item), {
                    progress
                }) : item)
        }),
    [uploadSuccess.toString()]: (state, { payload })=>{
        const fileUploadInfo = state.fileUploads.find((item)=>payload.uploadId === item.uploadId);
        if (!fileUploadInfo) {
            return state;
        }
        return _object_spread_props(_object_spread({}, state), {
            fileUploads: state.fileUploads.filter((item)=>payload.uploadId !== item.uploadId),
            fileUploadsCompleted: [
                _object_spread_props(_object_spread({}, fileUploadInfo), {
                    deviationId: payload.deviationId
                }),
                ...state.fileUploadsCompleted
            ]
        });
    },
    [cancelFileUpload.toString()]: (state, { payload: { uploadId } })=>_object_spread_props(_object_spread({}, state), {
            fileUploads: state.fileUploads.filter((item)=>item.uploadId !== uploadId),
            fileUploadsWaiting: state.fileUploadsWaiting.filter((item)=>item.uploadId !== uploadId)
        }),
    [clearInactiveUploads.toString()]: (state)=>_object_spread_props(_object_spread({}, state), {
            fileUploads: state.fileUploads.filter((item)=>!item.error),
            fileUploadsCompleted: []
        }),
    [uploadAttachment.toString()]: (state, { payload })=>_object_spread_props(_object_spread({}, state), {
            attachmentUploadsWaiting: [
                ...state.attachmentUploadsWaiting,
                _object_spread({}, payload)
            ]
        }),
    [uploadAttachmentImmediately.toString()]: (state, { payload })=>_object_spread_props(_object_spread({}, state), {
            attachmentUploads: [
                ...state.attachmentUploads,
                _object_spread({}, payload)
            ],
            attachmentUploadsWaiting: state.attachmentUploadsWaiting.filter((f)=>f.uploadId !== payload.uploadId)
        }),
    [uploadAttachmentFailure.toString()]: (state, { payload: { uploadId, error } })=>_object_spread_props(_object_spread({}, state), {
            attachmentUploads: [
                ...state.attachmentUploads
            ].map((item)=>item.uploadId === uploadId ? _object_spread_props(_object_spread({}, item), {
                    error
                }) : item)
        }),
    [uploadAttachmentProgress.toString()]: (state, { payload: { uploadId, progress } })=>_object_spread_props(_object_spread({}, state), {
            attachmentUploads: [
                ...state.attachmentUploads
            ].map((item)=>item.uploadId === uploadId ? _object_spread_props(_object_spread({}, item), {
                    progress
                }) : item)
        }),
    [uploadAttachmentSuccess.toString()]: (state, { payload })=>{
        const attachmentUploadInfo = state.attachmentUploads.find((item)=>payload.uploadId === item.uploadId);
        if (!attachmentUploadInfo) {
            return state;
        }
        return _object_spread_props(_object_spread({}, state), {
            attachmentUploads: state.attachmentUploads.filter((item)=>payload.uploadId !== item.uploadId),
            attachmentUploadsCompleted: [
                attachmentUploadInfo,
                ...state.attachmentUploadsCompleted
            ]
        });
    },
    [cancelAttachmentUpload.toString()]: (state, { payload: { uploadId } })=>_object_spread_props(_object_spread({}, state), {
            attachmentUploads: state.attachmentUploads.filter((item)=>item.uploadId !== uploadId),
            attachmentUploadsWaiting: state.attachmentUploadsWaiting.filter((item)=>item.uploadId !== uploadId)
        }),
    [uploadDocument.toString()]: (state, { payload })=>_object_spread_props(_object_spread({}, state), {
            documentUploads: _object_spread_props(_object_spread({}, state.documentUploads), {
                [payload.documentType]: payload
            })
        }),
    [uploadDocumentProgress.toString()]: (state, { payload: { documentType, progress } })=>_object_spread_props(_object_spread({}, state), {
            documentUploads: _object_spread_props(_object_spread({}, state.documentUploads), {
                [documentType]: _object_spread_props(_object_spread({}, state.documentUploads[documentType]), {
                    progress
                })
            })
        }),
    [uploadDocumentSuccess.toString()]: (state, { payload: { documentType, documentUrl } })=>{
        return _object_spread_props(_object_spread({}, state), {
            documentUploads: _object_spread_props(_object_spread({}, state.documentUploads), {
                [documentType]: _object_spread_props(_object_spread({}, state.documentUploads[documentType]), {
                    documentUrl
                })
            })
        });
    },
    [uploadDocumentFailure.toString()]: (state, { payload: { documentType, error } })=>_object_spread_props(_object_spread({}, state), {
            documentUploads: _object_spread_props(_object_spread({}, state.documentUploads), {
                [documentType]: _object_spread_props(_object_spread({}, state.documentUploads[documentType]), {
                    error
                })
            })
        }),
    [cancelDocumentUpload.toString()]: (state, { payload: { documentType } })=>_object_spread_props(_object_spread({}, state), {
            documentUploads: _object_spread_props(_object_spread({}, state.documentUploads), {
                [documentType]: undefined
            })
        })
}, defaultState);
const reducers = {
    [actionKey]: actionHandlers
};
export default reducers;

//# sourceMappingURL=reducers.js.map